import Vue from "vue";
import Page from "@/components/layout/Page";
import InformationBlock from "@/components/layout/InformationBlock";

Vue.component("page", Page);
Vue.component("information-block", InformationBlock);
